import {
  Paper,
  TextField,
  Grid,
  MenuItem,
  Button,
  stepButtonClasses,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
} from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getUserById, updateUserById } from "../../api/user";
import { role } from "../../config/roles";
import useSnackbar from "../../hooks/useSnackbar.js";
import {
  deleteCustomerById,
  getCustomerById,
  updateCustomerById,
} from "../../api/customer";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { parseISO } from "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import useErrorHandler from "../../hooks/useErrorHandler";

export default function CustomerDetail() {
  const { data: user } = useSelector((state) => state.user);
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const handleError = useErrorHandler();
  const snackbar = useSnackbar();

  const [customerData, setCustomerData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    zipcode: "",
    address: "",
    address2: "",
    country: "",
    subscription_end_date: "",
    subscription_start_date: "",
    company_name: "",
    created_at: "",
    isvalidate: false,
    payment_date: "",
    password: "",
  });

  const [editDisabled, setEditDisabled] = useState(true);

  useEffect(() => {
    if (!user.token) return;
    getCustomerById(user.token, params.id)
      .then(({ data }) => {
        console.log("");
        setCustomerData(extractCustomerData(data.data));
      })
      .catch((err) => {
        handleError(err);
      });
  }, [user.token]);

  function onDetailsChange({ target }) {
    setCustomerData((prev) => ({ ...prev, [target.name]: target.value }));
  }
  const [phoneError, setPhoneError] = useState("");

  async function onCustomerUpdate(e) {
    e.preventDefault();
    if (customerData.phone.length !== 10) {
      setPhoneError("Please enter a valid 10-digit phone number");
      return;
    }
    setPhoneError("");
    try {
      await updateCustomerById(
        user.token,
        params.id,
        getUpdatableProfileData(customerData)
      );

      snackbar.showSuccess("User Updated");
      setEditDisabled(true);
      navigate("/customer");
    } catch (error) {
      handleError(error);
      snackbar.showError();
    }
  }

  const handleDelete = async () => {
    try {
      await deleteCustomerById(params.id, user.token);
      snackbar.showSuccess("Customer Deleted.");
      navigate("/customer");
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <>
      <Paper className="odr-card">
        <Box
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
          mb={0}
        >
          <Typography className="heading-title">User Details</Typography>
        </Box>
        {/* {user.roles === "REGISTRAR" ? (
            <></>
          ) : ( */}

        {/* )} */}

        <Box component="form" onSubmit={onCustomerUpdate} className="px-4 pb-6">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="First Name"
                name="firstname"
                value={customerData.firstname}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Last Name"
                name="lastname"
                required
                value={customerData.lastname}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                type="tel"
                inputProps={{ maxLength: 10 }}
                disabled={editDisabled}
                label="Phone"
                name="phone"
                value={customerData.phone}
                required
                error={!!phoneError}
                helperText={phoneError}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                type="email"
                disabled={true}
                label="Email"
                name="email"
                value={customerData.email}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Password"
                name="password"
                value={customerData.password}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Address"
                name="address"
                value={customerData.address}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Address Line 2"
                name="address2"
                value={customerData.address2}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="City"
                name="city"
                value={customerData.city}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="State"
                name="state"
                value={customerData.state}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Zipcode"
                name="zipcode"
                value={customerData.zipcode}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Country"
                name="country"
                value={customerData.country}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Company Name"
                name="company_name"
                value={customerData.company_name}
                required
              />
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Subscription Start Date"
                  required
                  disabled={editDisabled}
                  //   minDateTime={parseISO(new Date().toISOString())}
                  value={customerData.subscription_start_date}
                  onChange={(newValue) => {
                    onDetailsChange({
                      target: {
                        name: "subscription_start_date",
                        value: newValue,
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      fullWidth
                      size="small"
                      variant="outlined"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Subscription End Date"
                  disabled={editDisabled}
                  //   minDateTime={parseISO(
                  //     data.start || new Date().toISOString()
                  //   )}
                  value={customerData.subscription_end_date}
                  onChange={(newValue) => {
                    onDetailsChange({
                      target: {
                        name: "subscription_end_date",
                        value: newValue,
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      variant="outlined"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Created At"
                  value={customerData.created_at}
                  disabled={editDisabled}
                  onChange={(newValue) => {
                    onDetailsChange({
                      target: {
                        name: "created_at",
                        value: newValue,
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      variant="outlined"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Payment Date"
                  disabled={editDisabled}
                  //   minDateTime={parseISO(
                  //     data.start || new Date().toISOString()
                  //   )}
                  value={customerData.payment_date}
                  onChange={(newValue) => {
                    onDetailsChange({
                      target: {
                        name: "payment_date",
                        value: newValue,
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      variant="outlined"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <FormControl disabled className="checkbox-button">
                <FormLabel className="!pr-4">Validate</FormLabel>
                <RadioGroup
                  row
                  value={customerData.isvalidate ? true : false}
                  onChange={() => {}}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="YES"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="NO"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Box display="flex" columnGap={1} justifyContent="flex-end">
                {editDisabled ? (
                  <></>
                ) : (
                  <Button
                    size="large"
                    variant="contained"
                    color="warning"
                    type="submit"
                    className="blue-button"
                    // onClick={onProfileUpdate}
                  >
                    Save
                  </Button>
                )}
                <Button
                  size="large"
                  variant="text"
                //  color="warning"
                  className="red-boder-button"
                  onClick={handleDelete}
                  // onClick={onProfileUpdate}
                >
                  Delete
                </Button>

                <Button
                  size="large"
                  variant="outlined"
                  className="black-border-button"
                  disabled={/^trial_user$/i.test(user.roles) ? true : false}
                  onClick={() => setEditDisabled((prev) => !prev)}
                >
                  {editDisabled ? "Edit" : "Cancel"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
}

function extractCustomerData(data) {
  return {
    firstname: data.firstname || "",
    lastname: data.lastname || "",
    email: data.email || "",
    phone: data.phone || "",
    city: data.city || "",
    state: data.state || "",
    zipcode: data.zipcode || "",
    address: data.address || "",
    address2: data.address2 || "",
    country: data.country || "",
    subscription_end_date: data.subscription_end_date || "",
    subscription_start_date: data.subscription_start_date || "",
    company_name: data.company_name || "",
    created_at: data.created_at || "",
    isvalidate: data.isvalidate || false,
    payment_date: data.payment_date || "",
    password: data.password || "",
  };
}

function getUpdatableProfileData(data) {
  return {
    firstname: data.firstname,
    lastname: data.lastname,
    phone: data.phone,
    city: data.city,
    state: data.state,
    zipcode: data.zipcode,
    address: data.address,
    address2: data.address2,
    country: data.country,
    subscription_end_date: data.subscription_end_date || null,
    subscription_start_date: data.subscription_start_date || null,
    company_name: data.company_name || "",
    created_at: data.created_at || null,
    isvalidate: data.isvalidate || false,
    payment_date: data.payment_date || null,
    password: data.password || "",
  };
}
